// Capstone Project
// John, Isabel, Nick, Bobur

import { Table } from "reactstrap";
import SingleSpace from "./SingleSpace";

const SpaceTable = (props) => {
  return (
    <>
      <Table className="table-parking table table-borderless">
        <h2>Parking Spaces</h2>
        <thead>
          <tr>
            <th>Number</th>
            <th>Description</th>
            <th>Pricing</th>
            <th>Size</th>
            <th>In-Use / Reserved</th>
          </tr>
        </thead>
        <tbody>
          {props.parkingSpaces?.map((parkingSpace, index) => (
            <SingleSpace
              key={index}
              parkingSpace={parkingSpace}
              token={props.token}
              showAllLotsSpaces={props.showAllLotsSpaces}
            />
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default SpaceTable;
